import type { WritingExpressionItem } from '../writingExpressionBank';

/** Korean writing scaffolds — discourse relations; shared by TOPIK writing. */
export const KOREAN_WRITING_EXPRESSIONS: readonly WritingExpressionItem[] = [
  // introduce
  { id: 'ko-introduce-1', category: 'introduce', text: '먼저', gloss: '首先' },
  { id: 'ko-introduce-2', category: 'introduce', text: '우선', gloss: '首先 / 优先' },
  { id: 'ko-introduce-3', category: 'introduce', text: '이 글에서는 …에 대해 다루고자 한다.', gloss: '本文拟讨论…' },
  { id: 'ko-introduce-4', category: 'introduce', text: '최근 …이/가 중요한 문제로 떠오르고 있다.', gloss: '近来…成为重要问题' },
  { id: 'ko-introduce-5', category: 'introduce', text: '안녕하세요.', gloss: '您好（书信/邮件开场）' },
  // continue
  { id: 'ko-continue-1', category: 'continue', text: '다음으로', gloss: '接下来' },
  { id: 'ko-continue-2', category: 'continue', text: '이와 관련하여', gloss: '与此相关' },
  { id: 'ko-continue-3', category: 'continue', text: '또한 주목할 점은', gloss: '另外值得注意的是' },
  { id: 'ko-continue-4', category: 'continue', text: '이 점에서', gloss: '在这一点上' },
  // finally
  { id: 'ko-finally-1', category: 'finally', text: '끝으로', gloss: '最后' },
  { id: 'ko-finally-2', category: 'finally', text: '마지막으로', gloss: '最后一点' },
  { id: 'ko-finally-3', category: 'finally', text: '결국', gloss: '最终' },
  // cause_reason
  { id: 'ko-cause-reason-1', category: 'cause_reason', text: '왜냐하면', gloss: '因为' },
  { id: 'ko-cause-reason-2', category: 'cause_reason', text: '…때문에', gloss: '由于…' },
  { id: 'ko-cause-reason-3', category: 'cause_reason', text: '…으로 인해', gloss: '因…而' },
  { id: 'ko-cause-reason-4', category: 'cause_reason', text: '그 까닭은', gloss: '其原因是' },
  // cause_result
  { id: 'ko-cause-result-1', category: 'cause_result', text: '따라서', gloss: '因此' },
  { id: 'ko-cause-result-2', category: 'cause_result', text: '그 결과', gloss: '结果' },
  { id: 'ko-cause-result-3', category: 'cause_result', text: '이로 인해', gloss: '由此' },
  { id: 'ko-cause-result-4', category: 'cause_result', text: '이런 이유로', gloss: '基于这一原因' },
  // contrast_turn
  { id: 'ko-contrast-turn-1', category: 'contrast_turn', text: '그러나', gloss: '然而' },
  { id: 'ko-contrast-turn-2', category: 'contrast_turn', text: '하지만', gloss: '但是' },
  { id: 'ko-contrast-turn-3', category: 'contrast_turn', text: '반면에', gloss: '相比之下' },
  { id: 'ko-contrast-turn-4', category: 'contrast_turn', text: '이와 달리', gloss: '与此不同' },
  // contrast_concede
  { id: 'ko-contrast-concede-1', category: 'contrast_concede', text: '비록 …지만', gloss: '虽然…但是…' },
  { id: 'ko-contrast-concede-2', category: 'contrast_concede', text: '…에도 불구하고', gloss: '尽管…' },
  { id: 'ko-contrast-concede-3', category: 'contrast_concede', text: '물론 …다. 그러나', gloss: '诚然…但是…' },
  { id: 'ko-contrast-concede-4', category: 'contrast_concede', text: '인정하건대', gloss: '不得不承认' },
  // parallel_add
  { id: 'ko-parallel-add-1', category: 'parallel_add', text: '또한', gloss: '另外' },
  { id: 'ko-parallel-add-2', category: 'parallel_add', text: '그리고', gloss: '并且' },
  { id: 'ko-parallel-add-3', category: 'parallel_add', text: '게다가', gloss: '再加上' },
  { id: 'ko-parallel-add-4', category: 'parallel_add', text: '이와 더불어', gloss: '与此同时' },
  // parallel_choice
  { id: 'ko-parallel-choice-1', category: 'parallel_choice', text: '…거나 …거나', gloss: '要么…要么…' },
  { id: 'ko-parallel-choice-2', category: 'parallel_choice', text: '아니면', gloss: '或者' },
  { id: 'ko-parallel-choice-3', category: 'parallel_choice', text: '그렇지 않으면', gloss: '否则' },
  // progressive
  { id: 'ko-progressive-1', category: 'progressive', text: '더욱이', gloss: '更有甚者' },
  { id: 'ko-progressive-2', category: 'progressive', text: '나아가', gloss: '更进一步' },
  { id: 'ko-progressive-3', category: 'progressive', text: '뿐만 아니라', gloss: '不仅如此' },
  // compare
  { id: 'ko-compare-1', category: 'compare', text: '마찬가지로', gloss: '同样地' },
  { id: 'ko-compare-2', category: 'compare', text: '비슷하게', gloss: '类似地' },
  { id: 'ko-compare-3', category: 'compare', text: '같은 방식으로', gloss: '以同样的方式' },
  // juxtapose
  { id: 'ko-juxtapose-1', category: 'juxtapose', text: '…와/과 달리', gloss: '与…不同' },
  { id: 'ko-juxtapose-2', category: 'juxtapose', text: '대조적으로', gloss: '对照来看' },
  { id: 'ko-juxtapose-3', category: 'juxtapose', text: '한편으로는 … 다른 한편으로는', gloss: '一方面…另一方面…' },
  // exemplify
  { id: 'ko-exemplify-1', category: 'exemplify', text: '예를 들어', gloss: '例如' },
  { id: 'ko-exemplify-2', category: 'exemplify', text: '예컨대', gloss: '譬如' },
  { id: 'ko-exemplify-3', category: 'exemplify', text: '구체적으로는', gloss: '具体来说' },
  { id: 'ko-exemplify-4', category: 'exemplify', text: '한 가지 예로', gloss: '举一个例子' },
  // exception
  { id: 'ko-exception-1', category: 'exception', text: '…을/를 제외하고', gloss: '除…以外' },
  { id: 'ko-exception-2', category: 'exception', text: '…을/를 빼고는', gloss: '除去…' },
  { id: 'ko-exception-3', category: 'exception', text: '단,', gloss: '但（例外说明）' },
  // emphasize
  { id: 'ko-emphasize-1', category: 'emphasize', text: '특히', gloss: '特别是' },
  { id: 'ko-emphasize-2', category: 'emphasize', text: '무엇보다', gloss: '最重要的是' },
  { id: 'ko-emphasize-3', category: 'emphasize', text: '강조하건대', gloss: '需要强调的是' },
  // condition
  { id: 'ko-condition-1', category: 'condition', text: '만약 …다면', gloss: '如果…' },
  { id: 'ko-condition-2', category: 'condition', text: '…는 한', gloss: '只要…' },
  { id: 'ko-condition-3', category: 'condition', text: '…지 않는 한', gloss: '除非…' },
  { id: 'ko-condition-4', category: 'condition', text: '…경우', gloss: '倘若…的话' },
  // summarize
  { id: 'ko-summarize-1', category: 'summarize', text: '결론적으로', gloss: '总之' },
  { id: 'ko-summarize-2', category: 'summarize', text: '요약하면', gloss: '概括来说' },
  { id: 'ko-summarize-3', category: 'summarize', text: '이상을 종합하면', gloss: '综合以上' },
  { id: 'ko-summarize-4', category: 'summarize', text: '이러한 이유로', gloss: '基于以上理由' },
  // purpose
  { id: 'ko-purpose-1', category: 'purpose', text: '…기 위해', gloss: '为了…' },
  { id: 'ko-purpose-2', category: 'purpose', text: '…을/를 목적으로', gloss: '以…为目的' },
  { id: 'ko-purpose-3', category: 'purpose', text: '…도록', gloss: '以便…' },
  // restate
  { id: 'ko-restate-1', category: 'restate', text: '다시 말해', gloss: '换言之' },
  { id: 'ko-restate-2', category: 'restate', text: '즉', gloss: '也就是说' },
  { id: 'ko-restate-3', category: 'restate', text: '달리 말하면', gloss: '换种说法' },
  // temporal
  { id: 'ko-temporal-1', category: 'temporal', text: '그다음에', gloss: '然后' },
  { id: 'ko-temporal-2', category: 'temporal', text: '이전에', gloss: '此前' },
  { id: 'ko-temporal-3', category: 'temporal', text: '이후에', gloss: '随后' },
  { id: 'ko-temporal-4', category: 'temporal', text: '동시에', gloss: '与此同时' },
  // basis
  { id: 'ko-basis-1', category: 'basis', text: '…에 따르면', gloss: '根据…' },
  { id: 'ko-basis-2', category: 'basis', text: '…을/를 바탕으로', gloss: '基于…' },
  { id: 'ko-basis-3', category: 'basis', text: '…을/를 고려할 때', gloss: '考虑到…' },
  { id: 'ko-basis-4', category: 'basis', text: '…에 비추어', gloss: '鉴于…' },
];
